import Tracker from '@openreplay/tracker';

let tracker = null;

// Create a shared tracker instance
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_STAGE === "prod") {
  tracker = new Tracker({
    projectKey: "0KPfcCe9ht2ktLmx3oer",
    ingestPoint: "https://openreplay.languify.in/ingest",
    network: {
      failuresOnly: false, // Capture all network requests, not just failures
      capturePayload: true, // Capture request and response payloads
      captureInIframes: true, // Capture network requests made within iframes
    }
  });
}

const initOpenReplay = () => {
  if (tracker) tracker.start();
};

export { tracker, initOpenReplay };
